import { useEffect, useMemo, useState } from "react";
import "./ReceptorDatosPage.css";

const ENDPOINT = "https://appcorp.parma.com.gt/apipp/ReceptorDatos";

const baseRequest = {
  token:
    "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
  ambiente: "DESA",
  marca: "SAMSUNG",
  modelo: "S22002B",
  version: "Android 18.125",
  powerStatus: "84%",
  wifiStatus: "Conected to iphone de Mauricio",
  gpsStatus: "ON",
  gps: "321|-485|321",
  codigoUsuario: "",
  userNickName: "pierril",
};

const initialIncidencia = {
  codigoColaborador: "5244",
  nombreColaborador: "Mauricio Andre Hurtado Locon",
  codigoTipoIncidencia: "",
  tipoIncidencia: "VACACIONES",
  fechaInicio: "2026-06-18",
  fechaFin: "2026-06-20",
  primerDiaHoraInicio: "",
  primerDiaHoraFin: "",
  ultimoDiaHoraInicio: "12:00",
  ultimoDiaHoraFin: "17:00",
  observacion: "Vacaciones: primeros dos dias completos, ultimo dia parcial",
};

const initialFilters = {
  codigoIncidencia: "",
  codigoColaborador: "",
  tipoIncidencia: "",
  fechaInicio: "",
  fechaFin: "",
};

function emptyToNull(value) {
  return value === "" ? null : value;
}

function parseApiResponse(body) {
  if (typeof body === "string") {
    try {
      return JSON.parse(body);
    } catch {
      return body;
    }
  }

  if (typeof body?.Metodo?.Datos_Generados === "string") {
    return parseApiResponse(body.Metodo.Datos_Generados);
  }

  if (typeof body?.Metodo?.datos_Generados === "string") {
    return parseApiResponse(body.Metodo.datos_Generados);
  }

  if (typeof body?.Datos_Generados === "string") {
    return parseApiResponse(body.Datos_Generados);
  }

  if (typeof body?.datos_Generados === "string") {
    return parseApiResponse(body.datos_Generados);
  }

  return body;
}

function normalizeRows(data) {
  const parsed = parseApiResponse(data);

  if (typeof parsed?.RESP === "string") {
    return normalizeRows(parsed.RESP);
  }

  return Array.isArray(parsed?.RESP)
    ? parsed.RESP
    : Array.isArray(parsed)
      ? parsed
      : [];
}

function normalizeTipos(data) {
  return normalizeRows(data).map((tipo) => ({
    codigo: String(tipo.ti_codigo),
    nombre: tipo.ti_nombre,
    descripcion: tipo.ti_descripcion,
  }));
}

function buildDatosRecibidos(tipoOperacion, data = {}) {
  if (tipoOperacion === "SelectTipoIncidencia") {
    return {
      TipoOperacion: "SelectTipoIncidencia",
      in_codigo: null,
      in_codigo_colaborador: null,
      ti_nombre: null,
      in_fecha_inicio: null,
      in_fecha_fin: null,
    };
  }

  if (tipoOperacion === "SelectVistaSegmentada") {
    return {
      TipoOperacion: "SelectVistaSegmentada",
      in_codigo: data.codigoIncidencia ? Number(data.codigoIncidencia) : null,
      in_codigo_colaborador: data.codigoColaborador
        ? Number(data.codigoColaborador)
        : null,
      ti_nombre: data.tipoIncidencia || null,
      in_fecha_inicio: data.fechaInicio || null,
      in_fecha_fin: data.fechaFin || null,
    };
  }

  return {
    TipoOperacion: "Insert",
    in_codigo_colaborador: Number(data.codigoColaborador),
    in_nombre_colaborador: data.nombreColaborador,
    in_codigo_tipo_incidencia: data.codigoTipoIncidencia
      ? Number(data.codigoTipoIncidencia)
      : null,
    ti_nombre: data.tipoIncidencia,
    in_fecha_inicio: data.fechaInicio,
    in_fecha_fin: data.fechaFin,
    in_primer_dia_hora_inicio: emptyToNull(data.primerDiaHoraInicio),
    in_primer_dia_hora_fin: emptyToNull(data.primerDiaHoraFin),
    in_ultimo_dia_hora_inicio: emptyToNull(data.ultimoDiaHoraInicio),
    in_ultimo_dia_hora_fin: emptyToNull(data.ultimoDiaHoraFin),
    in_observacion: data.observacion,
  };
}

function buildPayload(tipoOperacion, datos) {
  return {
    Token: baseRequest.token,
    Ambiente: baseRequest.ambiente,
    Dispositivo: {
      Marca: baseRequest.marca,
      Modelo: baseRequest.modelo,
      Version: baseRequest.version,
      McAdress: null,
      PowerStatus: baseRequest.powerStatus,
      WifiStatus: baseRequest.wifiStatus,
      GPSStatus: baseRequest.gpsStatus,
      GPS: baseRequest.gps,
    },
    User: {
      Codigo: baseRequest.codigoUsuario,
      UserNickName: baseRequest.userNickName,
    },
    Metodo: {
      NombreMetodo: "ControlIncidencias",
      Datos_Recibidos: JSON.stringify(buildDatosRecibidos(tipoOperacion, datos)),
      Datos_Generados: "",
    },
  };
}

async function sendReceptorRequest(tipoOperacion, datos) {
  const response = await fetch(ENDPOINT, {
    method: "POST",
    headers: {
      accept: "*/*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(buildPayload(tipoOperacion, datos)),
  });

  const contentType = response.headers.get("content-type") || "";
  const body = contentType.includes("application/json")
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    throw new Error(
      `Error ${response.status}: ${
        typeof body === "string" ? body : JSON.stringify(body)
      }`
    );
  }

  return parseApiResponse(body);
}

function formatDate(value) {
  if (!value) return "-";
  return String(value).slice(0, 10);
}

function formatTime(value) {
  if (!value) return "-";
  return String(value).slice(0, 5);
}

export default function ReceptorDatosPage() {
  const [form, setForm] = useState(initialIncidencia);
  const [filters, setFilters] = useState(initialFilters);
  const [incidencias, setIncidencias] = useState([]);
  const [tiposIncidencia, setTiposIncidencia] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [loadingTipos, setLoadingTipos] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const insertPreview = useMemo(
    () => JSON.stringify(buildDatosRecibidos("Insert", form), null, 2),
    [form]
  );

  const updateForm = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const updateFilter = (event) => {
    const { name, value } = event.target;
    setFilters((current) => ({ ...current, [name]: value }));
  };

  const updateTipoIncidencia = (event) => {
    const selected = tiposIncidencia.find(
      (tipo) => tipo.codigo === event.target.value
    );

    setForm((current) => ({
      ...current,
      codigoTipoIncidencia: selected?.codigo || event.target.value,
      tipoIncidencia: selected?.nombre || current.tipoIncidencia,
    }));
  };

  const updateTipoIncidenciaManual = (event) => {
    setForm((current) => ({
      ...current,
      codigoTipoIncidencia: "",
      tipoIncidencia: event.target.value,
    }));
  };

  const loadTiposIncidencia = async () => {
    setLoadingTipos(true);

    try {
      const data = await sendReceptorRequest("SelectTipoIncidencia");
      const rows = normalizeTipos(data);
      setTiposIncidencia(rows);

      if (!form.codigoTipoIncidencia && rows.length > 0) {
        const currentTipo =
          rows.find(
            (tipo) =>
              tipo.nombre.toLowerCase() === form.tipoIncidencia.toLowerCase()
          ) || rows[0];

        setForm((current) => ({
          ...current,
          codigoTipoIncidencia: currentTipo.codigo,
          tipoIncidencia: currentTipo.nombre,
        }));
      }
    } catch (error) {
      setMessage(error.message || "No se pudo cargar el combo de incidencias.");
    } finally {
      setLoadingTipos(false);
    }
  };

  const loadIncidencias = async (filterValues = filters) => {
    setLoadingList(true);
    setMessage("");

    try {
      const data = await sendReceptorRequest("SelectVistaSegmentada", filterValues);
      setIncidencias(normalizeRows(data));
    } catch (error) {
      setMessage(error.message || "No se pudo listar las incidencias.");
    } finally {
      setLoadingList(false);
    }
  };

  const saveIncidencia = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage("");

    try {
      await sendReceptorRequest("Insert", form);
      setMessage("Incidencia insertada correctamente.");
      setForm((current) => ({
        ...initialIncidencia,
        codigoTipoIncidencia: current.codigoTipoIncidencia,
        tipoIncidencia: current.tipoIncidencia,
      }));
      await loadIncidencias();
    } catch (error) {
      setMessage(error.message || "No se pudo insertar la incidencia.");
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    loadTiposIncidencia();
    loadIncidencias(initialFilters);
  }, []);

  return (
    <main className="receptor-page">
      <section className="receptor-header">
        <div>
          <p className="receptor-kicker">ControlIncidencias</p>
          <h1>Incidencias RH</h1>
        </div>
        <button
          className="receptor-secondary"
          type="button"
          onClick={() => loadIncidencias()}
          disabled={loadingList}
        >
          {loadingList ? "Actualizando..." : "Actualizar lista"}
        </button>
      </section>

      {message ? <p className="receptor-alert">{message}</p> : null}

      <section className="receptor-layout">
        <form className="receptor-panel receptor-form" onSubmit={saveIncidencia}>
          <h2>Nueva incidencia</h2>

          <div className="receptor-row receptor-row--three">
            <label>
              Codigo colaborador
              <input
                name="codigoColaborador"
                value={form.codigoColaborador}
                onChange={updateForm}
                inputMode="numeric"
                required
              />
            </label>
            <label>
              Nombre colaborador
              <input
                name="nombreColaborador"
                value={form.nombreColaborador}
                onChange={updateForm}
                required
              />
            </label>
            <label>
              Tipo incidencia
              <select
                name="codigoTipoIncidencia"
                value={form.codigoTipoIncidencia}
                onChange={updateTipoIncidencia}
                disabled={loadingTipos}
                required
              >
                <option value="">
                  {loadingTipos ? "Cargando..." : "Seleccione"}
                </option>
                {tiposIncidencia.map((tipo) => (
                  <option key={tipo.codigo} value={tipo.codigo}>
                    {tipo.nombre}
                  </option>
                ))}
              </select>
            </label>
          </div>

          {tiposIncidencia.length === 0 ? (
            <label>
              Tipo incidencia manual
              <input
                name="tipoIncidencia"
                value={form.tipoIncidencia}
                onChange={updateTipoIncidenciaManual}
                placeholder="Ej. VACACIONES"
                required
              />
            </label>
          ) : null}

          <div className="receptor-row">
            <label>
              Fecha inicio
              <input
                type="date"
                name="fechaInicio"
                value={form.fechaInicio}
                onChange={updateForm}
                required
              />
            </label>
            <label>
              Fecha fin
              <input
                type="date"
                name="fechaFin"
                value={form.fechaFin}
                onChange={updateForm}
                required
              />
            </label>
          </div>

          <div className="receptor-row receptor-row--four">
            <label>
              Primer dia inicio
              <input
                type="time"
                name="primerDiaHoraInicio"
                value={form.primerDiaHoraInicio}
                onChange={updateForm}
              />
            </label>
            <label>
              Primer dia fin
              <input
                type="time"
                name="primerDiaHoraFin"
                value={form.primerDiaHoraFin}
                onChange={updateForm}
              />
            </label>
            <label>
              Ultimo dia inicio
              <input
                type="time"
                name="ultimoDiaHoraInicio"
                value={form.ultimoDiaHoraInicio}
                onChange={updateForm}
              />
            </label>
            <label>
              Ultimo dia fin
              <input
                type="time"
                name="ultimoDiaHoraFin"
                value={form.ultimoDiaHoraFin}
                onChange={updateForm}
              />
            </label>
          </div>

          <label>
            Observacion
            <textarea
              name="observacion"
              value={form.observacion}
              onChange={updateForm}
              rows={3}
              required
            />
          </label>

          <details className="receptor-preview">
            <summary>Ver datos que se insertan</summary>
            <pre>{insertPreview}</pre>
          </details>

          <footer className="receptor-actions">
            <button type="submit" disabled={saving}>
              {saving ? "Insertando..." : "Insertar incidencia"}
            </button>
          </footer>
        </form>

        <section className="receptor-panel receptor-list-panel">
          <div className="receptor-list-heading">
            <h2>Incidencias insertadas</h2>
            <span>{incidencias.length} registros</span>
          </div>

          <div className="receptor-filters">
            <label>
              Buscar por incidencia
              <input
                name="codigoIncidencia"
                value={filters.codigoIncidencia}
                onChange={updateFilter}
                inputMode="numeric"
              />
            </label>
            <label>
              Colaborador
              <input
                name="codigoColaborador"
                value={filters.codigoColaborador}
                onChange={updateFilter}
                inputMode="numeric"
              />
            </label>
            <label>
              Tipo
              <select
                name="tipoIncidencia"
                value={filters.tipoIncidencia}
                onChange={updateFilter}
                disabled={loadingTipos}
              >
                <option value="">Todos</option>
                {tiposIncidencia.map((tipo) => (
                  <option key={tipo.codigo} value={tipo.nombre}>
                    {tipo.nombre}
                  </option>
                ))}
              </select>
            </label>
            <label>
              Desde
              <input
                type="date"
                name="fechaInicio"
                value={filters.fechaInicio}
                onChange={updateFilter}
              />
            </label>
            <label>
              Hasta
              <input
                type="date"
                name="fechaFin"
                value={filters.fechaFin}
                onChange={updateFilter}
              />
            </label>
            <button
              type="button"
              onClick={() => loadIncidencias()}
              disabled={loadingList}
            >
              Buscar
            </button>
          </div>

          <div className="receptor-table-wrap">
            <table className="receptor-table">
              <thead>
                <tr>
                  <th>Codigo</th>
                  <th>Colaborador</th>
                  <th>Tipo</th>
                  <th>Fecha</th>
                  <th>Dia</th>
                  <th>Horario</th>
                </tr>
              </thead>
              <tbody>
                {loadingList ? (
                  <tr>
                    <td colSpan={6}>Cargando incidencias...</td>
                  </tr>
                ) : incidencias.length === 0 ? (
                  <tr>
                    <td colSpan={6}>No hay incidencias para mostrar.</td>
                  </tr>
                ) : (
                  incidencias.map((item) => (
                    <tr key={item.Codigo_Incidencia_Segmentada}>
                      <td>
                        <strong>{item.Codigo_Incidencia}</strong>
                        <span>Seg. {item.Codigo_Incidencia_Segmentada}</span>
                      </td>
                      <td>
                        <strong>{item.Codigo_Colaboradores}</strong>
                        <span>{item.Nombre_Coloborador}</span>
                      </td>
                      <td>{item.tipo_incidencia}</td>
                      <td>{formatDate(item.Fecha)}</td>
                      <td>
                        {item.Dia_Completo ? "Completo" : "Parcial"}
                      </td>
                      <td>
                        {item.Dia_Completo
                          ? "-"
                          : `${formatTime(item.Hora_Inicio)} - ${formatTime(
                              item.Hora_Fin
                            )}`}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </section>
      </section>
    </main>
  );
}
